import { useContext, useEffect, useState } from "react";
import MenuContext from "src/_components/ContextAPI";
import Page404 from "src/views/pages/page404/Page404";

const RouteComponentLoader = ({
  component: Component,
  accessKey: AccessKey,
  path: Path,
  ...rest
}) => {
  const { cgmfRouteListData } = useContext(MenuContext);
  const [loaded, setLoaded] = useState(false);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    // Simulate loading delay

    const isMatchAccessKey = cgmfRouteListData?.some(
      (existingItem) => existingItem.accessKey === AccessKey
    );

    const isMatch = cgmfRouteListData?.some(
      (existingItem) => existingItem.toURL === Path
    );

    console.log(
      "AccessKey : ",
      AccessKey,
      "| Path : ",
      Path,
      "| isMatchAccessKey : ",
      isMatchAccessKey,
      "| isMatch : ",
      isMatch
    );

    if (isMatchAccessKey === true || isMatch === true) {
      setLoaded(true);
    } else {
      setLoaded(false);
    }

    const delay = setTimeout(() => {
      setLoad(true);
    }, 250);

    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return load ? (
    loaded ? (
      <Component {...rest} />
    ) : (
      <Page404 {...rest} />
    )
  ) : (
    <div
      style={{
        textAlign: "center",
        fontWeight: "500",
        fontSize: "1.53125rem",
        lineHeight: "1.2",
        marginTop: "40px",
      }}
    >
      Loading ...
    </div>
  );
};

export default RouteComponentLoader;
